var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFboArrowDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.26783 13.469L11.6478 21.859C11.8378 22.049 12.1478 22.049 12.3378 21.859L20.7278 13.469C21.0378 13.159 20.8178 12.629 20.3778 12.629H18.9878C18.8578 12.629 18.7378 12.679 18.6378 12.769L12.9778 18.449V2.48902C12.9778 2.21902 12.7578 1.99902 12.4878 1.99902H11.5078C11.2378 1.99902 11.0178 2.21902 11.0178 2.48902V18.449L5.34783 12.779C5.25783 12.689 5.12783 12.639 4.99783 12.639H3.61783C3.17783 12.639 2.96783 13.169 3.26783 13.479V13.469Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFboArrowDown);
export default __webpack_public_path__ + "static/media/FBOArrowDown.61f716803a8f88ee2dae4c30c285aa65.svg";
export { ForwardRef as ReactComponent };